import {
	Card,
	CardBody,
	Input,
	Table,
	TableCell,
	TableContainer,
	TableHeader,
	Button,
} from '@windmill/react-ui';
import { Tabs, Tab } from '@mui/material';
import TripadvanceApprovalTable from 'components/tripadvanceapproval/TripadvanceApprovalTable';
import DataWrapper from './DataWrapper';
import NotFound from 'components/table/NotFound';
import PageTitle from 'components/Typography/PageTitle';
import useFilter from 'hooks/useFilter';
import { useState, useEffect, useContext } from 'react';
import TripadvanceApprovalServices from 'services/TripadvanceApprovalServices';
import Somethingwentwrong from 'pages/Somethingwentwrong';
import { SidebarContext } from 'context/SidebarContext';
import sidebar from 'routes/sidebar';
import LabelArea from 'components/form/LabelArea';
import InputSearchDate from 'components/form/InputSearchDate';

const TripadvanceApproval = () => {
	const adminInfo = localStorage.getItem('adminInfo')
		? JSON.parse(localStorage.getItem('adminInfo'))
		: null;

	const [loading, setLoading] = useState(false);
	const { isUpdate, setIsUpdate } = useContext(SidebarContext);
	const [itemsPerPage,setItemsPerPage] = useState(10);
	const [tab, setTab] = useState(0);
	const [billapprovalData, setTripadvanceApprovalData] = useState([]);
	// const [paymentStatus, setPaymentStatus] = useState("unpaid");
	const [status, setStatus] = useState(false);
	const {
		billapprovalRef,
		dataTable,
		serviceData,
		handleSubmitTripadvanceApproval,
		//   currentPage,
	} = useFilter(billapprovalData, itemsPerPage);
	      useEffect(() => {
    if (dataTable.length !== 0) {
      setItemsPerPage(dataTable.length);
    }
  }, [dataTable]);
	const [error, setError] = useState(false);
	const [searchstartDate, setSearchStartDate] = useState(null);
	const [searchendDate, setSearchEndDate] = useState(null);
	// const formatDate = (date) => {
	//   if (!date) return null;
	//   const d = new Date(date);
	//   const day = String(d.getDate()).padStart(2, "0");
	//   const month = String(d.getMonth() + 1).padStart(2, "0");
	//   const year = d.getFullYear();
	//   return `${day}-${month}-${year}`;
	// };
	// const formattedDates = {
	//   start_date: searchstartDate ? formatDate(searchstartDate) : "",
	//   end_date: searchendDate ? formatDate(searchendDate) : "",
	// };
	useEffect(() => {
		const fetchTripadvanceApproval = async () => {
			setLoading(true);

			try {
				let response;

				let payload = {
					employee_id: adminInfo?.id, // Use stored employee_id if available
					type: 1, // Default type
				};

				if (tab === 1) {
					payload.type = 2;
				} else if (tab === 2) {
					payload.type = 3; // Assuming type 3 for tab 2
				}
				response = await TripadvanceApprovalServices.billapprovalList(payload);

				const updatedData =
					response?.data?.map(
						({
							ref_no,
							client_name,
							start_date,
							bill_amount,
							approval_status,
							vendor_id,
							...rest
						}) => ({
							ref_no,
							client_name,
							start_date,
							bill_amount,
							approval_status,
							vendor_id,
							...rest,
						})
					) || [];

				setTripadvanceApprovalData(updatedData);
				setStatus(response?.status);
			} catch (error) {
				setError(true);
				console.error('Error fetching tripadvanceapproval:', error);
				setStatus(false);
			} finally {
				setLoading(false);
			}
		};

		fetchTripadvanceApproval();
		setIsUpdate(false);

		// eslint-disable-next-line
	}, [tab, isUpdate]); //   Fixed syntax error

	const handleTabChange = (event, newValue) => {
		setTab(newValue);
	};

	const handleSearch = () => {
		setIsUpdate(true);
	};
	const currentPage = 1;
	const isAdmin = adminInfo?.id === 1;

	const hideView = isAdmin
		? true
		: adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'trip advance approval' && perm.view === 1
		  );

	return (
		<>
			{hideView && (
				<>
					<PageTitle sidebar={sidebar().sidebar} />
					<Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800">
						<CardBody>
							<div className="flex flex-wrap items-center gap-3">
								<div className="flex items-center gap-3">
									<div className="flex items-center gap-2">
										<LabelArea label="Start Date" />
										<div className="w-50">
											<InputSearchDate
												value={searchstartDate}
												onChange={(event) => setSearchStartDate(event)}
											/>
										</div>
									</div>

									<div className="flex items-center gap-2">
										<LabelArea label="End Date" />
										<div className="w-50">
											<InputSearchDate
												value={searchendDate}
												min={searchstartDate}
												onChange={(event) => setSearchEndDate(event)}
											/>
										</div>
									</div>
								</div>

								<div className="flex-1">
									<Input
										ref={billapprovalRef}
										className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
										type="search"
										name="search"
										placeholder="Quick Search"
										onChange={handleSubmitTripadvanceApproval}
									/>
								</div>

								<Button
									className="rounded-md h-10 px-8"
									onClick={() => {
										handleSearch();
									}}
								>
									Search
								</Button>
							</div>
						</CardBody>
					</Card>
					<Tabs
						value={tab}
						onChange={handleTabChange}
						TabIndicatorProps={{
							style: { backgroundColor: '#057a55' },
						}}
						sx={{
							'& .MuiTab-root': {
								textTransform: 'capitalize',
							},
						}}
					>
						{/* <Tab label="All" /> */}
						<Tab
							className="focus:outline-none dark:text-gray-300"
							sx={{ '&.Mui-selected': { color: '#057a55', outline: 'none' } }}
							label="Pending"
						/>
						<Tab
							className="focus:outline-none dark:text-gray-300"
							sx={{ '&.Mui-selected': { color: '#057a55', outline: 'none' } }}
							label="Paid"
						/>
						<Tab
							className="focus:outline-none dark:text-gray-300"
							sx={{ '&.Mui-selected': { color: '#057a55', outline: 'none' } }}
							label="All"
						/>
					</Tabs>
					<DataWrapper loading={loading} error={error} status={status}>
						{serviceData?.length !== 0 ? (
							<TableContainer
								style={{
									maxHeight: '65vh',
									overflow: 'scroll',
									scrollbarWidth: 'thin',
								}}
							>
								<Table>
									<TableHeader className="custom-table-header text-center capitalize sticky top-0 z-10">
										<tr>
											<TableCell>Sl.No.</TableCell>
											<TableCell>Ref No.</TableCell>

											<TableCell>Client Name</TableCell>
											<TableCell>Travel Date</TableCell>
											<TableCell>Arrival</TableCell>
											<TableCell>Transporter</TableCell>

											<TableCell>Trip Advance Request</TableCell>
											<TableCell>Trip Advance paid</TableCell>
											<TableCell>balance amount</TableCell>
											<TableCell>Paid status</TableCell>
											<TableCell>paid date</TableCell>
											<TableCell>Payment Type</TableCell>
											<TableCell>paid remark</TableCell>
											<TableCell>Actions</TableCell>
										</tr>
									</TableHeader>
									<TripadvanceApprovalTable
										tripadvanceapproval={dataTable}
										billAmount={dataTable?.adjust_amount}
										id_client={dataTable?.id_client}
										va_id={dataTable?.va_id}
										perpage={itemsPerPage}
										currentPage={currentPage}
										tab={tab}
									/>
								</Table>
							</TableContainer>
						) : (
							<>
								{status !== true ? (
									<Somethingwentwrong title="Something Went Wrong, Try After Sometime" />
								) : (
									<NotFound title="There are no Triadvance Approval." />
								)}
							</>
						)}
					</DataWrapper>
				</>
			)}
		</>
	);
};

export default TripadvanceApproval;
